export const buildFormData = (
  payload: Record<
    string,
    string | number | boolean | (string | number)[] | null | undefined
  >
) => {
  const formData = new FormData();
  for (const key in payload) {
    const val = payload[key];
    if (val === null || val === undefined) {
      continue;
    }

    if (Array.isArray(val)) {
      val.forEach((subval) => formData.append(key, subval.toString()));
    } else {
      formData.set(key, val.toString());
    }
  }
  return formData;
};
